type AnyError = any

const extractCode = (e: AnyError): string | undefined => {
  return e?.extensions?.code ?? e?.extensions?.exception?.code ?? e?.code
}

export const parseGraphQLErrorCodes = (error: AnyError) => {
  // ApolloError -> CombinedGraphQLErrors -> error.errors: GraphQLFormattedError[]
  const combined = Array.isArray(error?.errors) ? error.errors : null

  if (combined?.length) {
    const codes = combined.map(extractCode).filter(Boolean)

    return codes.length ? codes : undefined
  }

  // ApolloError -> error.graphQLErrors
  const gql = Array.isArray(error?.graphQLErrors) ? error.graphQLErrors : null

  if (gql?.length) {
    const codes = gql.map(extractCode).filter(Boolean)

    return codes.length ? codes : undefined
  }

  return error?.code
}
